import type { Resource } from '../../';
export const product_sizeChart_category_children: Resource = {"default":"Children"};
